import { Identifiable, ProjectStatus } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeProjectStatus(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<ProjectStatus>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/projectStatuses/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeProjectStatus };
